angular.module('app.factories').factory('formValidator', ($translate, notify) => (formSelector, scope) => {
    const fv = {
        scope,
        form: angular.element(formSelector),

        isValid(dontClearTabs) {
            if (!dontClearTabs) {
                jQuery('.uk-tab-error').removeClass('uk-tab-error');
            }

            return this.form.parsley().validate();
        },
    };

    fv.form
        .parsley()
        .on('form:submit', () => {
            if (!fv.isValid()) {
                notify.danger($translate.instant('fill_all_fields'));
            }

            // zawsze blokujemy wysłanie formularza
            return false;
        })
        .on('form:validated', (Parsley) => {
            // @todo: refactor
            if (fv.scope.$apply && !fv.scope.$$phase && !fv.scope.$root.$$phase) {
                fv.scope.$apply();
            }

            if (!Parsley.validationResult) {
                notify.danger($translate.instant('fill_all_fields'));

                // zaznacz odp. tab
                const tabId = Parsley.$element.closest('li.uk-tab-content').first().data('tabId');
                if (tabId) {
                    jQuery(`li.uk-tab-link[data-tab-id="${tabId}"]`).addClass('uk-tab-error');
                }
            }
        })
        .on('field:validated', (parsleyField) => {
            if ($(parsleyField.$element).hasClass('md-input')) {
                // @todo: refactor
                if (fv.scope.$apply && !fv.scope.$$phase && !fv.scope.$root.$$phase) {
                    fv.scope.$apply();
                }
            }
        });

    fv.form.find('[required]').each((i, input) => {
        const label = jQuery(input).parent().find('label:first');

        // add styles for required labels
        label.addClass('required-input');
    });

    // tabsy
    jQuery('.user_content .uk-tab').each((i, tab) => {
        jQuery(tab)
            .find('li')
            .each((j, li) => {
                jQuery(li).addClass('uk-tab-link').attr('data-tab-id', `${i}:${j}`);
            });
        jQuery(`#${jQuery(tab).attr('id')}_content`)
            .find('li')
            .each((j, li) => {
                jQuery(li).addClass('uk-tab-content').attr('data-tab-id', `${i}:${j}`);
            });
    });

    return fv;
});
